export const LocalStorage = {
  ACCESS_TOKEN: "ACCESS_TOKEN",
  STATE_CHANGE: "STATE_CHANGE",
  WORK_STATUS: "WORK_STATUS",
  REMEMBER_ME: "REMEMBER_ME",
  // WORK_STATUS_COLOR: "WORK_STATUS_COLOR",
  LOGIN_USER_CCAAS_DETAILS: "LOGIN_USER_CCAAS_DETAILS",
  AGENT_EXT: "AGENT_EXT",
  USER_DETAILS: "USER_DETAILS",
  USER_EMAIL: "USER_EMAIL",
  ROLE_ID: "ROLE_ID",
  REFRESH_TOKEN: "REFRESH_TOKEN",
  WSS_URL: "WSS_URL",
  VIDEO_WSS_URL:"VIDEO_WSS_URL",
  PASSWORD: "PASSWORD",
  LOGIN_TIME: "LOGIN_TIME",
  COUNTRY_CODE: "COUNTRY_CODE",
  COUNTRY_CODE_NO: "COUNTRY_CODE_NO",
  PRODUCT_ID:"PRODUCT_ID",
  PLAN_ID:"PLAN_ID",
  K_WEB_ID:"K_WEB_ID",
  SHOPIFY_CRED:"SHOPIFY_CRED",
  BIGCOMMERCE_CRED:"BIGCOMMERCE_CRED",
  BIGCOMMERCE_SOURCE : 'SOURCE',
  WIX_CRED : "WIX_CRED",
  IS_LOGIN_INIT_FUNC : "IS_LOGIN_INIT_FUNC"
};
